export default "__VITE_ASSET__By0v2CUh__"